'use client';
import React, { useContext } from 'react';
var DateRangePickerContext = /*#__PURE__*/React.createContext({});
export var useDateRangePickerContext = function useDateRangePickerContext() {
  return useContext(DateRangePickerContext) || {};
};
export default DateRangePickerContext;